import { navMenuList } from '../constants';

export const isNavMenuRoute = () => {
  const path = window.location.pathname;
  return navMenuList.includes(path) ? path : '';
};



// WEBPACK FOOTER //
// ./utils/navBar.js